import React from 'react'
import { Link } from 'react-router-dom'

function Blog() {
    return (
        <>
            <section>
                <div className="container">
                    <div className="row align-items-end mb-5">
                        <div className="col-12 col-md-12 col-lg-4">
                            <div>
                                <h2 className="mb-0">
                                    <span className="font-w-4 d-block">Blog</span>
                                </h2>
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-5 ps-lg-5 my-3 my-lg-0">
                            <p className="lead mb-0">
                                Your source for inspection knowledge and smart car buying.
                            </p>
                        </div>
                        <div className="col-12 col-md-12 col-lg-3 text-lg-end">
                            <Link to="/blog-list" className="btn btn-primary"> View More Posts</Link>
                            {/* <a href="blog-listing.html" className="btn btn-primary">
                                View More Post
                            </a> */}
                        </div>
                    </div>
                    {/* <!-- / .row --> */}
                    <div className="row">
                        <div className="col-md-6 col-lg-4 mb-5 mb-lg-0">
                            {/* <!-- Blog Card --> */}
                            <div className="card border-0 shadow bg-transparent">
                                <picture>
                                    <source media="(max-width: 768px)" srcSet={require("../../assets/images/blog/mobile/01.webp")} />
                                    <source media="(min-width: 769px)" srcSet={require("../../assets/images/blog/desktop/01.webp")} />
                                    <img
                                        className="card-img-top"
                                        src={require("../../assets/images/blog/desktop/01.webp")}
                                        alt="pre purchase inspection"
                                        loading='lazy'
                                    />
                                </picture>
                                <div className="card-body p-4">
                                    <div>
                                        <div className="d-inline-block bg-light text-center px-2 py-1 rounded me-2">
                                            {/* <span className="text-primary">12</span> Apr */}
                                        </div>
                                        {/* <a className="d-inline-block btn-link" href="/">Sass</a> */}
                                    </div>
                                    <h2 className="h5">
                                        <Link to="/blog-detail/what-is-a-pre-purchase-car-inspection" className="link-title" >
                                            What Is a Pre-Purchase Car Inspection? &nbsp;
                                        </Link>
                                    </h2>
                                    {/* <ul className="list-inline mb-0">
                                        <li className="list-inline-item pe-3">
                                            <a href="/" className="list-group-item-action"
                                            ><i
                                                className="lar la-user-circle me-1 text-primary ic-1x"
                                            ></i>
                                                Admin</a>
                                        </li>
                                        <li className="list-inline-item pe-3">
                                            <a href="/" className="list-group-item-action"
                                            ><i className="las la-eye me-1 text-primary ic-1x"></i>
                                                275</a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="/" className="list-group-item-action"
                                            ><i
                                                className="lar la-comments me-1 text-primary ic-1x"
                                            ></i>
                                                300</a>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                            {/* <!-- End Blog Card --> */}
                        </div>
                        <div className="col-md-6 col-lg-4 mb-5 mb-lg-0">
                            {/* <!-- Blog Card --> */}
                            <div className="card border-0 shadow bg-transparent">
                                <picture>
                                    <source media="(max-width: 768px)" srcSet={require("../../assets/images/blog/mobile/02.webp")} />
                                    <source media="(min-width: 769px)" srcSet={require("../../assets/images/blog/desktop/02.webp")} />
                                    <img
                                        className="card-img-top"
                                        src={require("../../assets/images/blog/desktop/02.webp")}
                                        alt="Why a Pre-Purchase Car Inspection Could Save You Thousands"
                                        loading='lazy'
                                    />
                                </picture>
                                <div className="card-body p-4">
                                    <div>
                                        <div className="d-inline-block bg-light text-center px-2 py-1 rounded me-2">
                                            {/* <span className="text-primary">12</span> Apr */}
                                        </div>
                                    </div>
                                    <h2 className="h5">
                                        <Link to="/blog-detail/why-a-pre-purchase-car-inspection-could-save-you-thousands" className="link-title">
                                            Why a Pre-Purchase Car Inspection Could Save You Thousands
                                        </Link>
                                    </h2>
                                </div>
                            </div>
                            {/* <!-- End Blog Card --> */}
                        </div>
                        <div className="col-md-6 col-lg-4">
                            {/* <!-- Blog Card --> */}
                            <div className="card border-0 shadow bg-transparent">
                                <picture>
                                    <source media="(max-width: 768px)" srcSet={require("../../assets/images/blog/mobile/04.webp")} />
                                    <source media="(min-width: 769px)" srcSet={require("../../assets/images/blog/desktop/04.webp")} />
                                    <img
                                        className="card-img-top"
                                        src={require("../../assets/images/blog/desktop/04.webp")}
                                        alt="Warning Signs to Watch for When Buying a Used Vehicle"
                                        loading='lazy'
                                    />
                                </picture>
                                <div className="card-body p-4">
                                    <div>
                                        <div className="d-inline-block bg-light text-center px-2 py-1 rounded me-2">
                                            {/* <span className="text-primary">12</span> Apr */}
                                        </div>
                                    </div>
                                    <h2 className="h5">
                                        <Link to="/blog-detail/warning-signs-to-watch-for-when-buying-a-used-vehicle" className="link-title" >
                                            Top 5 Warning Signs to Watch for When Buying a Used Vehicle
                                        </Link>
                                    </h2>

                                </div>
                            </div>
                            {/* <!-- End Blog Card --> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blog
